import { IPostBankNote } from '../models/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { CommonPostResponse } from '../../../components/models/models'

export class AddBankNoteApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/dealerPaymentOperation/bankNoteAdd',
      requesterInfo,
    })
  }

  public async addBankNote(request: IPostBankNote[]): Promise<CommonPostResponse> {
    return await this.postAsync<CommonPostResponse>(request)
  }
}
